import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/api.service';
import { SettingsService } from 'src/app/settings.service';
import { ThemingService } from 'src/app/theming.service';
import { LambdaService } from 'src/app/lambda.service';
declare let $: any;

@Component({
  selector: 'app-sub-categories',
  templateUrl: './sub-categories.component.html',
  styleUrls: ['./sub-categories.component.scss']
})
export class SubCategoriesComponent implements OnInit {
  @Input() categoryId!: string;
  @Input() subCategoryId!: string;
  subCategories: any[] = [];
  loading: boolean = false;
  searchString: string = '';
  modalDelete = false;
  subCategoryIdToDelete: any;
  category: any;
  categories: any[] = [];
  subCategory: any;
  showCreateSubCategoryModal = false;
  showEditSubCategoryModal = false;
  selectedSubCategoryId!: string;
  selectedCategoryId!: string;
  timekitResources: any[] = [];

  constructor(
    private apiService: ApiService,
    public themingService: ThemingService,
    public router: Router,
    private settingsService: SettingsService,
    private lambdaService: LambdaService
  ) { }

  ngOnInit(): void {
    this.getCategories()
    this.getSubCategoryByCategoryId(parseInt(this.categoryId));
  }

  getSubCategoryByCategoryId(categoryId: number) {
    this.loading = true;
    this.lambdaService.getSubCategoryByCategoryId(categoryId, this.themingService.shopId)
      .then((data: any) => {
        this.subCategories = data.subCategories;

        // Verificar que timekitResources ya ha sido cargado antes de mapear
        if (this.timekitResources.length > 0) {
          this.subCategories.forEach(subCategory => {
            const resource = this.timekitResources.find(
              (r: { timekitResourceId: any; }) => r.timekitResourceId === subCategory.timekitResourceId
            );
            subCategory.resourceName = resource ? resource.resourceName : 'No Resource';
          });
        } else {
          console.warn("timekitResources aún no se han cargado");
        }

        this.loading = false;
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }


  async deleteSubCategory(response: number) {
    if (response && this.subCategoryIdToDelete !== null) {
      this.loading = true;
      try {
        const subCategory = this.subCategories.find(subCat => subCat.subCategoryId === this.subCategoryIdToDelete);
        if (subCategory && subCategory.subCategoryImageUrl) {
          await this.deleteImage(subCategory.subCategoryImageUrl);
        }
        await this.lambdaService.deleteSubCategory(this.themingService.shopId, this.subCategoryIdToDelete);
        this.getSubCategoryByCategoryId(parseInt(this.categoryId));
        $('#deleteSubCategoryModal').modal('show');
      } catch (error) {
        console.error('Error deleting category:', error);
      } finally {
        this.loading = false;
        this.modalDelete = false;
      }
    } else {
      this.modalDelete = false;
    }
  }

  async deleteImage(imageUrl: string) {
    try {
      await this.lambdaService.deleteFile(imageUrl);
    } catch (error) {
      console.log('Error deleting image:', error);
    }
  }

  async getCategories() {
    this.loading = true;
    try {
      const response: any = await this.lambdaService.getCategories(this.themingService.shopId);
      const categories = Array.isArray(response[0]) ? response[0] : [];
      this.categories = categories;
    } catch (error) {
      console.error('Error fetching categories:', error);
    } finally {
      this.loading = false;
    }
  }


  openCreateSubCategoryModal() {
    this.showCreateSubCategoryModal = true;
  }

  closeCreateSubCategoryModal() {
    this.showCreateSubCategoryModal = false;
  }

  handleSubCategoryCreated() {
    this.showCreateSubCategoryModal = false;
    this.getSubCategoryByCategoryId(parseInt(this.categoryId));
  }

  openEditsubCategoryModal(subCategoryId: string) {
    this.selectedSubCategoryId = subCategoryId;
    this.selectedCategoryId = this.categoryId;
    this.showEditSubCategoryModal = true;
  }

  handleSubCategoryUpdated() {
    this.showEditSubCategoryModal = false;
    this.getSubCategoryByCategoryId(parseInt(this.categoryId));
  }

  closeEditSubCategoryModal() {
    this.showEditSubCategoryModal = false;
  }

  closeModal() {
    $('#deleteSubCategoryModal').modal('hide');
  }
}
